/* eslint-disable unused-imports/no-unused-vars */
import React from 'react';
import {
  Box,
  FormControl,
  MenuItem,
  Slider,
  InputAdornment,
} from '@mui/material';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import Typography from '@/components/typography/typography';
import TextField from '@/components/text-field/text-field';
import Select from '@/components/select/select';
import formatText from '@/utils/format-text';

interface DividerControlsProps {
  attrs: Record<string, any>;
  updateAttrs: (attr: Record<string, any>) => void;
}

const DividerControls: React.FC<DividerControlsProps> = ({
  attrs,
  updateAttrs,
}) => {
  const { styles } = attrs
  return (
    <>
      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <Select
          label='Style'
          value={styles?.borderStyle}
          onChange={(e) => updateAttrs({ styles: { borderStyle: e.target.value } })}
          renderValue={(value) => formatText(value)}
        >
          <MenuItem value="solid">Solid</MenuItem>
          <MenuItem value="dashed">Dashed</MenuItem>
          <MenuItem value="dotted">Dotted</MenuItem>
        </Select>
      </FormControl>
      <Box sx={{ mb: 1 }}>
        <Typography type="s5" color='theme.secondary.800' weight='medium'>
          Thickness (px)
        </Typography>
        <Slider
          value={styles?.borderWidth}
          onChange={(_, value) => updateAttrs({ styles: { borderWidth: value as number } })}
          min={1}
          max={10}
          step={1}
          valueLabelDisplay="auto"
          size="small"
          sx={(theme) => ({
            '& .MuiSlider-rail': {
              color: theme.palette.theme.primary[500],
            },
            '& .MuiSlider-thumb': {
              color: theme.palette.theme.primary[800],
            },
            '& .MuiSlider-track': {
              color: theme.palette.theme.primary[600],
            },
          })}
        />
      </Box>
      <Box sx={{ mb: 2 }}>
        <TextField
          label="Divider Color"
          type="color"
          value={styles?.borderColor || '#000000'}
          onChange={(e) => updateAttrs({ styles: { ...styles, borderColor: e.target.value } })}
          size="small"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" sx={{ ml: 0.5, mr: 0.5 }}>
                <ColorLensIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
          sx={{
            '& input[type="color"]': {
              padding: 0,
              margin: '6px 12px 6px 0',
              cursor: 'pointer',
              height: '18px',
              width: 'calc(100% - 12px)',
              border: 'none',
              WebkitAppearance: 'none',
              '&::-webkit-color-swatch-wrapper': {
                padding: 0,
              },
              '&::-webkit-color-swatch': {
                border: '1px solid',
                borderColor: '#e0e0e0',
                borderRadius: '4px',
              },
              '&::-moz-color-swatch': {
                border: '1px solid',
                borderColor: '#e0e0e0',
                borderRadius: '4px',
              }
            }
          }}
        />
      </Box>
    </>
  );
};

export default DividerControls;